import { Theme } from '@cmctechnology/webinvest-constants';
import { IThemeConfigOverrides, generateTheme } from './theme';
import { getBaseColours, getBrandColours, getEoraThemeColours } from '../fundamentals/colours/eoraColourUtils';
import { cmcDarkThemeConfig, cmcThemeConfig } from './cmc';
import merge from 'lodash.merge';
import { themeBrandRadiusSizes } from '../fundamentals/sizes/borderRadius';
import { BaseColours, baseColours } from '../fundamentals/colours/baseColours';
import { generateUIControlsColours } from '../fundamentals/colours/generateUiColours';

export const themeSetUp = (
  theme: Theme,
  darkMode: boolean,
  legacyThemeConfigOverrides: Omit<IThemeConfigOverrides, 'eoraColours'>,
  componentOverrides: any
) => {
  const eoraColours = getEoraThemeColours(theme, darkMode);
  const eoraBaseColours = getBaseColours(eoraColours.eoraCoreColours, darkMode);
  const brandColours = getBrandColours(eoraColours.eoraBrandColours);
  const themeConfigOverrides: IThemeConfigOverrides = {
    ...legacyThemeConfigOverrides,
    baseColours: merge(baseColours, eoraBaseColours) as BaseColours,
    eoraColours,
    brandColours,
    isDarkMode: darkMode
  };

  const mergedTheme = generateTheme(merge({}, darkMode ? cmcDarkThemeConfig : cmcThemeConfig, themeConfigOverrides));

  const uiControlsColours = {
    ...generateUIControlsColours(mergedTheme.colours, brandColours.primary.colour)
  };

  return {
    ...merge({}, mergedTheme, { ...componentOverrides, ...uiControlsColours, buttonTabBadgeBorderRadius: themeBrandRadiusSizes(theme) }),
    name: `${theme}${darkMode ? 'Dark' : ''}`
  };
};
